import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewComponent } from './view.component';
import { FormsModule }   from '@angular/forms';
import {PdfViewerModule} from "ng2-pdf-viewer";
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, PdfViewerModule, SharedModule],
    declarations: [ViewComponent],
    exports: [ViewComponent]
})

export class ViewModule { }
